import { useMemo } from 'react';
import { useFavoriteAggregations } from '../../../providers/FavoriteAggregationsContext';
import type { MarketSelectorItem, MarketSelectorPreset } from '../types';
import { getSelectionsFromPreset } from '../useMarketSelector';
import { useMarketSelectorAggregationPresets } from './useMarketSelectorAggregationPresets';

/**
 * Favorited trading aggregations that resolve to at least one selectable item, sorted by label.
 * Backs the prev/next aggregation arrows on market data and prediction cards.
 */
export function useFavoriteAggregationPresets(itemsMap: Map<string, MarketSelectorItem>): MarketSelectorPreset[] {
  const { favoriteAggregationsSet } = useFavoriteAggregations();
  const { aggregationPresets } = useMarketSelectorAggregationPresets();

  return useMemo(() => {
    return (aggregationPresets ?? [])
      .filter(preset => favoriteAggregationsSet.has(preset.id))
      .filter(preset => getSelectionsFromPreset(preset, itemsMap).length > 0)
      .toSorted((a, b) => a.label.localeCompare(b.label));
  }, [aggregationPresets, favoriteAggregationsSet, itemsMap]);
}
